export const sampleEssayContent1 = `저는 A 기업에 지원한 동기가 혁신적인 기술 개발에 대한 열정 때문입니다. 학부 시절부터 인공지능과 빅데이터 분야에 깊은 관심을 가지고 연구해 왔으며, A 기업이 이 분야에서 선도적인 역할을 하고 있다는 점에 큰 매력을 느꼈습니다.

특히, 3학년 때 참여했던 '스마트 시티 프로젝트'에서 도시 교통 최적화 알고리즘을 개발한 경험이 저의 진로를 결정짓는 계기가 되었습니다. 이 프로젝트를 통해 실제 도시 문제를 AI 기술로 해결할 수 있다는 가능성을 체감했고, 이는 제가 A 기업에 지원하게 된 직접적인 동기가 되었습니다.

A 기업의 '지속 가능한 미래를 위한 AI 솔루션' 비전에 깊이 공감합니다. 저는 기술이 단순히 편리함을 넘어 사회 문제 해결에 기여해야 한다고 믿습니다. 졸업 논문으로 진행했던 '환경 오염 예측 모델 개발' 연구에서 이러한 믿음을 실천에 옮겼고, 이 경험은 A 기업의 비전과 완벽히 일치한다고 생각합니다.

입사 후에는 A 기업의 'AI for Good' 프로젝트에 참여하고 싶습니다. 제가 가진 기술적 지식과 사회 문제에 대한 관심을 결합하여, 환경, 교육, 의료 등 다양한 분야에서 AI 기술을 활용한 솔루션을 개발하고 싶습니다. 특히, 개발도상국의 교육 격차 해소를 위한 AI 튜터링 시스템 개발에 관심이 많습니다.

또한, A 기업의 글로벌 네트워크를 통해 다양한 문화와 관점을 접하고 싶습니다. 학부 시절 교환학생으로 1년간 미국에서 공부한 경험이 있는데, 이때 다양성의 가치를 깊이 이해하게 되었습니다. A 기업에서 일하며 전 세계의 동료들과 협업하고 새로운 아이디어를 교환하는 과정에서 더욱 성장할 수 있을 것이라 믿습니다.

마지막으로, A 기업의 지속적인 학습과 혁신을 추구하는 문화에 큰 매력을 느낍니다. 기술의 발전 속도가 빠른 만큼, 끊임없이 새로운 것을 배우고 도전하는 자세가 중요하다고 생각합니다. A 기업에서 제공하는 다양한 교육 프로그램과 프로젝트 기회를 통해 저의 역량을 끊임없이 발전시키고 싶습니다.

저는 A 기업에서 제가 가진 기술적 역량, 혁신에 대한 열정, 그리고 사회적 가치 창출에 대한 의지를 모두 실현할 수 있을 것이라 확신합니다. A 기업의 일원으로서 함께 성장하고, 더 나은 미래를 만들어가는 여정에 동참하고 싶습니다. 감사합니다.`;

export const sampleEssayContent2 = `B 회사의 글로벌 비즈니스 전략에 깊은 인상을 받아 지원하게 되었습니다. 특히 신흥 시장에서의 혁신적인 접근 방식이 제 관심을 끌었습니다. 국제 경영학을 전공하면서 글로벌 시장의 다양성과 도전에 대해 배웠고, 이를 실제 비즈니스 환경에서 적용하고 싶었습니다.

대학 시절 참여했던 '글로벌 마케팅 전략 공모전'에서 동남아 시장 진출 전략을 수립한 경험이 있습니다. 이 과정에서 문화적 차이를 고려한 마케팅 전략의 중요성을 깨달았고, B 회사의 현지화 전략과 일맥상통한다고 생각했습니다.

또한, B 회사의 지속 가능한 비즈니스 모델에 큰 매력을 느꼈습니다. 경제적 이익뿐만 아니라 사회적 책임을 다하는 기업 철학이 제 가치관과 일치합니다. 학부 때 진행한 '사회적 기업의 국제화 전략' 연구를 통해, 비즈니스를 통한 사회 문제 해결의 가능성을 확인했고, B 회사에서 이를 실현하고 싶습니다.

입사 후에는 B 회사의 신흥 시장 개척 팀에 참여하고 싶습니다. 제가 가진 국제 경영 지식과 다문화에 대한 이해를 바탕으로, 새로운 시장에서의 기회를 발굴하고 현지화 전략을 수립하는 데 기여하고 싶습니다.

B 회사의 글로벌 인재 육성 프로그램도 큰 관심사입니다. 다양한 국가의 지사를 경험하며 글로벌 비즈니스 감각을 키우고, 국제적 네트워크를 구축하고 싶습니다. 이를 통해 더 넓은 시야와 다양한 관점을 가진 글로벌 리더로 성장하고자 합니다.

마지막으로, B 회사의 혁신적인 기업 문화에 동참하고 싶습니다. 급변하는 글로벌 시장에서 유연하게 대응하고, 창의적인 아이디어를 자유롭게 제안할 수 있는 환경에서 일하고 싶습니다. 저의 도전 정신과 창의력을 발휘하여 B 회사의 글로벌 성장에 기여하겠습니다.

B 회사에서 글로벌 비즈니스 전문가로 성장하며, 회사의 지속적인 성장과 사회적 가치 창출에 이바지하고 싶습니다. 감사합니다.`;

export const sampleEssayContent3 = `C 기업의 지속 가능한 발전 목표에 크게 공감하여 지원하게 되었습니다. 환경 보호와 사회적 책임을 중시하는 C 기업의 비전이 제 가치관과 일치합니다. 환경공학을 전공하면서 지속 가능한 발전의 중요성을 깊이 이해하게 되었고, 이를 실제 기업 환경에서 실현하고 싶었습니다.

학부 시절 참여했던 '친환경 에너지 솔루션 개발 프로젝트'에서 태양광 발전 시스템의 효율성을 개선하는 연구를 진행했습니다. 이 경험을 통해 혁신적인 기술이 환경 문제 해결에 큰 역할을 할 수 있다는 것을 깨달았고, C 기업의 친환경 기술 개발 노력에 큰 매력을 느꼈습니다.

특히 C 기업의 '2050 탄소 중립' 목표에 깊이 공감합니다. 졸업 논문으로 진행한 '기업의 탄소 배출 저감 전략' 연구에서 다양한 산업 분야의 친환경 전환 사례를 분석했습니다. 이 과정에서 C 기업의 선도적인 노력이 업계에 미치는 긍정적인 영향을 확인할 수 있었고, 이에 동참하고 싶다는 열망이 커졌습니다.

입사 후에는 C 기업의 지속 가능성 전략 팀에 참여하고 싶습니다. 제가 가진 환경공학 지식과 연구 경험을 바탕으로, 기업의 환경 영향을 최소화하고 사회적 가치를 극대화하는 전략 수립에 기여하고 싶습니다. 특히 순환 경제 모델 구축과 재생 에너지 활용 확대 방안에 관심이 많습니다.

또한, C 기업의 글로벌 환경 보호 프로젝트에 참여하고 싶습니다. 대학 시절 해외 봉사 활동을 통해 경험한 개발도상국의 환경 문제 해결에 C 기업의 기술과 자원을 활용할 수 있는 방안을 모색하고 싶습니다.

C 기업의 혁신적인 R&D 문화도 큰 매력으로 다가옵니다. 지속적인 학습과 실험을 장려하는 분위기에서 최신 환경 기술 트렌드를 습득하고, 창의적인 아이디어를 실현할 수 있는 기회를 갖고 싶습니다.

C 기업에서 환경 전문가로 성장하며, 기업의 지속 가능한 발전과 더 나은 미래 창조에 기여하고 싶습니다. 함께 일할 수 있는 기회를 주셔서 감사합니다.`;

export const sampleEssayContent4 = `D 그룹의 다양성과 포용성 정책은 제가 추구하는 가치와 일치하여 지원하게 되었습니다. 저는 다양한 배경의 사람들이 서로 존중하며 협력할 때 더 큰 시너지가 발생한다고 믿습니다. 사회학을 전공하면서 조직 문화와 다양성의 중요성에 대해 깊이 연구했고, 이를 실제 기업 환경에서 실현하고 싶었습니다.

대학원에서 진행한 '직장 내 다양성과 생산성의 상관관계' 연구를 통해, 포용적인 조직 문화가 혁신과 성과 향상에 미치는 긍정적 영향을 확인했습니다. 이 과정에서 D 그룹의 선도적인 다양성 정책과 그 성과에 큰 감명을 받았고, 이에 동참하고 싶다는 열망이 커졌습니다.

특히 D 그룹의 '글로벌 인재 양성 프로그램'에 큰 관심이 있습니다. 다양한 문화적 배경을 가진 인재들이 협력하여 글로벌 비즈니스 과제를 해결하는 과정에서, 제 다문화 이해력과 커뮤니케이션 능력을 더욱 발전시키고 싶습니다.

입사 후에는 D 그룹의 인사 혁신팀에 참여하고 싶습니다. 제가 가진 사회학적 지식과 연구 경험을 바탕으로, 더욱 포용적이고 공정한 인사 정책을 수립하는 데 기여하고 싶습니다. 특히 세대 간, 문화 간 이해를 증진시키는 프로그램 개발에 관심이 많습니다.

또한, D 그룹의 사회공헌 활동에도 적극적으로 참여하고 싶습니다. 대학 시절 다문화 가정 지원 봉사 활동을 통해 경험한 사회 통합의 중요성을 기업의 사회적 책임과 연계하여, 더 큰 사회적 가치를 창출하는 방안을 모색하고 싶습니다.

D 그룹의 지속적인 학습 문화도 큰 매력으로 다가옵니다. 빠르게 변화하는 글로벌 비즈니스 환경에서, 다양성과 포용성에 대한 최신 트렌드와 베스트 프랙티스를 학습하고 적용할 수 있는 기회를 갖고 싶습니다.`;

export const sampleEssayContent5 = `E 주식회사의 혁신적인 제품 개발 과정에 참여하고 싶어 지원하게 되었습니다. 저의 창의적인 문제 해결 능력과 E 주식회사의 혁신 문화가 시너지를 낼 수 있을 것이라 확신합니다. 기계공학을 전공하면서 새로운 기술과 제품에 대한 열정을 키워왔고, E 주식회사가 이 분야의 선두 주자라는 점에 큰 매력을 느꼈습니다.

학부 시절 참여했던 '스마트 홈 디바이스 개발 프로젝트'에서 에너지 효율성을 30% 높인 IoT 기기를 설계한 경험이 있습니다. 이 과정에서 사용자 중심의 혁신적인 제품 개발의 중요성을 깨달았고, E 주식회사의 사용자 경험 중심 제품 철학과 일맥상통한다고 생각했습니다.

특히 E 주식회사의 '오픈 이노베이션' 정책에 깊이 공감합니다. 졸업 논문으로 진행한 '기업의 개방형 혁신 전략' 연구에서 다양한 이해관계자와의 협력이 혁신 속도와 품질을 높인다는 것을 확인했습니다. E 주식회사에서 이러한 협력적 혁신 과정에 참여하고 싶습니다.

입사 후에는 E 주식회사의 신제품 개발팀에 참여하고 싶습니다. 제가 가진 기계공학 지식과 창의적 문제 해결 능력을 바탕으로, 사용자들의 삶을 더 편리하고 풍요롭게 만드는 혁신적인 제품을 개발하는 데 기여하고 싶습니다. 특히 웨어러블 기기와 스마트 홈 솔루션 분야에 큰 관심이 있습니다.

또한, E 주식회사의 지속 가능한 제품 개발 노력에도 동참하고 싶습니다. 대학원에서 진행한 '친환경 소재를 활용한 제품 설계' 연구를 통해, 혁신과 지속가능성을 동시에 추구할 수 있다는 것을 배웠습니다. 이러한 경험을 살려 E 주식회사의 제품이 환경에 미치는 영향을 최소화하면서도 성능은 극대화할 수 있는 방안을 모색하고 싶습니다.

E 주식회사의 글로벌 인재 육성 프로그램도 큰 관심사입니다. 다양한 국가의 R&D 센터를 경험하며 글로벌 시장에 대한 이해를 넓히고, 국제적인 협업 능력을 키우고 싶습니다. 이를 통해 더 넓은 시야와 다양한 관점을 가진 글로벌 엔지니어로 성장하고자 합니다.

마지막으로, E 주식회사의 도전적이고 자유로운 기업 문화에 매력을 느낍니다. 실패를 두려워하지 않고 끊임없이 새로운 아이디어를 시도할 수 있는 환경에서, 저의 잠재력을 최대한 발휘하고 싶습니다. 

E 주식회사에서 혁신적인 제품 개발자로 성장하며, 회사의 지속적인 혁신과 성장에 기여하고 싶습니다. 함께 일할 수 있는 기회를 주셔서 감사합니다.`;

export const sampleEssays = [
  { id: 1, title: "합격자소서 1", content: sampleEssayContent1, company: "A 기업 00직무"},
  { id: 2, title: "합격자소서 2", content: sampleEssayContent2, company: "B 기업 00직무"},
  { id: 3, title: "합격자소서 3", content: sampleEssayContent3, company: "C 기업 00직무"},
  { id: 4, title: "합격자소서 4", content: sampleEssayContent4, company: "D 기업 00직무"},
  { id: 5, title: "합격자소서 5", content: sampleEssayContent5, company: "E 기업 00직무"},
];